import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--square",
  "use": "icon-play--square-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-play--square\"><path stroke=\"#fff\" d=\"M.5.5h79v79H.5z\" /><path d=\"M33 27.876 54 40 33 52.124V27.876Z\" fill=\"#fff\" stroke=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol